import classNames from "classnames";
import React from "react";
import { useIntl } from "react-intl";
import { ReactComponent as UpIcon } from "static/icons/up.svg";
import "./CollapseButton.scss";

interface CollapseButtonProps {
    className?: string;
    onClick: () => void
}

const CollapseButton = ({className, onClick} : CollapseButtonProps) => {
    const intl = useIntl();
    return (
        <div className={classNames("collapse-container", className)}>
            <button className="collapse-button-div" onClick={onClick}>
                <UpIcon className="minimized-button" />
                <span className="collapse-span">
                    {intl.formatMessage({ id: "case_management.collapse_text" })}
                </span>
            </button>
        </div>
    );
};

export default CollapseButton;
